import localStorageEffect from '@/utils/recoil/localStorageEffect';
import { atomFamily } from 'recoil';

const pinnedIdsState = atomFamily<string[], string /* section + userId */>({
  key: 'workspace-pinned-ids',
  default: [],
  effects: (section) => [localStorageEffect(`workspace-pinned-ids-${section}`)],
});

export { pinnedIdsState };
